// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"DU-z","inlineTitle":"EU-z","sponsoredAdsWrapper":"FU-z","marketplaceRecosWrapper":"GU-z"};